import { render } from "./ProjectIcon.vue?vue&type=template&id=65c97923&scoped=true&ts=true"
import script from "./ProjectIcon.vue?vue&type=script&lang=ts"
export * from "./ProjectIcon.vue?vue&type=script&lang=ts"

import "./ProjectIcon.vue?vue&type=style&index=0&id=65c97923&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c97923"]])

export default __exports__